<template>
  <a-card>
    <a-page-header
      :title="this.$route.query.name"
      :sub-title="this.$route.query.barcode"
      @back="() => this.$router.go(-1)" >
      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
      </div>
    </a-page-header>
    <s-table
      ref="table"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      rowKey="id"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="price_render" slot-scope="text">
        {{ (text / 100).toFixed(2) | numberFormat }}
      </div>
      <span slot="action" slot-scope="text, record" style="text-align: center">
        <template>
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </a-card>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '@/views/shop_goods/goods_price/CreateForm'

import { shopGoodsPriceList, shopGoodsPriceCreate, shopGoodsPriceEdit, shopGoodsPriceDelete } from '@/api/applet_goods'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: true,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '等级',
          dataIndex: 'level',
          align: 'center',
          ellipsis: true
        },
        {
          title: '价格',
          dataIndex: 'price',
          ellipsis: true,
          align: 'right',
          scopedSlots: { customRender: 'price_render' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return shopGoodsPriceList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.queryParam.barcode = this.$route.query.barcode
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
      this.confirmLoading = false
    },
    handleAddCancel () {
      this.visible = false

      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      this.mdl = record
      this.visible = true
      this.confirmLoading = false
    },
    handleDelete (record) {
      shopGoodsPriceDelete(record.id).then((res) => {
        console.log(res)
        this.$refs.table.refresh()
      })
    },
    handleOk () {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          values.price = values.price * 100
          if (this.mdl) {
            shopGoodsPriceEdit(values, this.mdl.id).then((res) => {
              console.log(res, '修改成功')
              this.visible = false
              this.$refs.table.refresh()
            }).finally(() => {
              this.confirmLoading = false
              form.resetFields()
            })
          } else {
            values.barcode = this.queryParam.barcode
            shopGoodsPriceCreate(values).then((res) => {
              console.log(res, '创建成功')
              this.visible = false
              this.$refs.table.refresh()
            }).finally(() => {
              this.confirmLoading = false
              form.resetFields()
            })
          }
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>
